import { Row, Col, Cell, Desc, Img } from 'work/Markdown.tsx';
import * as React from 'react';
export default {
  Row,
  Col,
  Cell,
  Desc,
  Img,
  React
};